import {lazy} from "react";

export const ReportIccidsLazy = lazy(()=>import('./ReportIccids'))